import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaHome,
  FaInfoCircle,
  FaServicestack,
  FaBriefcase,
  FaBlog,
  FaEnvelope,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaInstagram,
} from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import Logo from "../Assets/Logo/White Logo.png";

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 w-full z-[9999] font-sans">

      {/* ================= TOP BAR (BLUE) ================= */}
      <div className="hidden md:flex justify-between items-center bg-[#f99728] text-white px-6 py-2">

        {/* Social Icons */}
        <div className="flex gap-4 text-white text-lg">
          <FaFacebook className="hover:text-yellow-300 cursor-pointer" />
          <FaTwitter className="hover:text-yellow-300 cursor-pointer" />
          <FaLinkedin className="hover:text-yellow-300 cursor-pointer" />
          <FaInstagram className="hover:text-yellow-300 cursor-pointer" />
        </div>

        {/* Contact */}
        <div className="flex flex-col sm:flex-row gap-4 text-sm font-medium text-white">

          <span className="flex items-center gap-2">
            <FaPhoneAlt className="text-white text-sm" />
            +91 7834949503
          </span>

          <span className="flex items-center gap-2">
            <FaEnvelope className="text-white text-sm" />
            info@growthloomdigital.com
          </span>

        </div>
      </div>

      {/* ================= MAIN NAV (WHITE) ================= */}
      <div className="bg-black shadow-md flex items-center justify-between px-4 sm:px-6 lg:px-10 py-0">

        {/* Logo */}
        <Link to="/">
          <img src={Logo} alt="logo" className="h-16 sm:h-18 lg:h-24 object-contain" />
        </Link>

        {/* Desktop Menu */}
        <nav className="hidden lg:flex items-center gap-8 font-semibold text-[#f99728]">

          <Link to="/" className="flex items-center gap-2 hover:text-[#f99728]">
            <FaHome /> Home
          </Link>

          <Link to="/about" className="flex items-center gap-2 hover:text-[#f99728]">
            <FaInfoCircle /> About
          </Link>

          <Link to="/services" className="flex items-center gap-2 hover:text-[#f99728]">
            <FaServicestack /> Services
          </Link>

          <Link to="/ourwork" className="flex items-center gap-2 hover:text-[#f99728]">
            <FaBriefcase /> Work
          </Link>

          <Link to="/blog" className="flex items-center gap-2 hover:text-[#f99728]">
            <FaBlog /> Blog
          </Link>

          <Link to="/contact" className="flex items-center gap-2 hover:text-[#f99728]">
            <FaEnvelope /> Contact
          </Link>
        </nav>

        {/* Mobile Button */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="lg:hidden text-2xl text-gray-700"
        >
          {mobileOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* ================= MOBILE MENU ================= */}
      {mobileOpen && (
        <div className="lg:hidden bg-white px-6 py-4 flex flex-col gap-4 font-medium border-t">

          <Link to="/" className="flex items-center gap-2"><FaHome /> Home</Link>
          <Link to="/about" className="flex items-center gap-2"><FaInfoCircle /> About</Link>
          <Link to="/services" className="flex items-center gap-2"><FaServicestack /> Services</Link>
          <Link to="/ourwork" className="flex items-center gap-2"><FaBriefcase /> Work</Link>
          <Link to="/blog" className="flex items-center gap-2"><FaBlog /> Blog</Link>
          <Link to="/contact" className="flex items-center gap-2"><FaEnvelope /> Contact</Link>

        </div>
      )}
    </header>
  );
};

export default Header;